import module from 'colaborador/module'
import template from './template.html'
import { cloneDeep } from 'lodash'

export class ColaboradorCajaAhorroElementoComponent {
  idProyecto
  idColaborador
  data
  onClose
  procesando = false
  error = null

  constructor(ColaboradorCajaAhorroConcluir) {
    this.colaboradorCajaAhorroConcluirService = ColaboradorCajaAhorroConcluir
  }

  $onInit() {
    this.copia = cloneDeep(this.data)
    console.log('copia', this.copia)
  }

  concluir() {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    this.colaboradorCajaAhorroConcluirService.put(this.copia.idProyecto, this.copia.id)
      .then(() => { this.copia.concluido = true })
      .then(() => {
        this.data = this.copia
        this.onClose({ $event: { data: this.data } })
      })
      .catch((error) => { this.error = error.data || error })
      .finally(() => { this.procesando = false })
  }

  modificar() {
    this.modificando = true
  }

  confirmar(data) {
    this.modificando = false

    if (data) {
      this.data = this.copia
      this.onClose({ $event: { data: this.data } })
    }
  }

  finalizar(data) {
    if (data) {
      this.modificar()
    } else {
      this.onClose()
    }
  }
}

module.component('colaboradorCajaAhorroElemento', {
  controller: ColaboradorCajaAhorroElementoComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/cajaAhorro/aportaciones/elemento/component.js